import users from './users';

export default function* () {
    yield* [...users];
}
